import { Breadcrumb } from "@gull";
import { getFlightMarkup } from "app/services/AdminServices/bookingService";
import moment from "moment";
import Tooltip from "rc-tooltip";
import React, { useEffect, useState } from "react";
import {
  Button,
  Card,
  Col,
  Container,
  Form,
  Image,
  Modal,
  Row,
  Spinner,
} from "react-bootstrap";
import { Helmet } from "react-helmet";
import {
  FaLongArrowAltRight,
  FaPlaneArrival,
  FaPlaneDeparture,
} from "react-icons/fa";
import { MdOutlineLocationOn } from "react-icons/md";
import { useNavigate, useParams } from "react-router-dom";
import FareSummary from "./FareSummary";
import SsrInfo from "app/views/Admin/Flight/BookingDetails/SsrInfo";
export default function PreviewModal({
  response,
  show,
  setShow,
  offlineBooking,
  values,
  isLoading,
  affiliateResponse,
  calculateSSRAmount,
}) {
  const [pnrResponse, setPnrResponse] = useState(null);

  const [review, setReview] = useState(null);
  const [isShow, setIsShow] = useState(false);

  const bookingData = async (response) => {
    const reviewRes = JSON.parse(response?.reviewResponse);
    // console.log(reviewRes, "reviewRes");
    setReview(reviewRes);
    setIsShow(false);
  };

  const passengerData = async (response) => {
    const res = JSON.parse(response?.pnRresponse);
    // console.log(reviewRes, "reviewRes")
    setPnrResponse(res);
    // setReview(res);
    setIsShow(false);
  };
  const [flightCommTypeOnWard, setFlightCommTypeOnWard] = useState(null);
  const [
    totalCarrierServiceChargesOnWard,
    setTotalCarrierServiceChargesOnWard,
  ] = useState(0);

  const [flightCommTypeReturn, setFlightCommTypeReturn] = useState(null);
  const [
    totalCarrierServiceChargesReturn,
    setTotalCarrierServiceChargesReturn,
  ] = useState(0);
  const bookingCorrelationIdData = async (values) => {
    if (values?.tripType == "1") {
      ///Onward
      setFlightCommTypeOnWard(values.airlinesMarkupCom);
      setTotalCarrierServiceChargesOnWard(values.airlinesMarkup);
    } else {
      ///Onward
      setFlightCommTypeOnWard(values.airlinesMarkupCom);
      setTotalCarrierServiceChargesOnWard(values.airlinesMarkup);
      ///Return
      setFlightCommTypeReturn(values.airlinesMarkupComReturn);
      setTotalCarrierServiceChargesReturn(values.airlinesMarkupReturn);
    }
  };
  useEffect(() => {
    // debugger;
    bookingCorrelationIdData(values);
  }, [values]);
  useEffect(() => {
    // debugger;
    bookingData(response);
    passengerData(response);
  }, [response]);
  const getTimeDiffFromDate = (startDate, endDate) => {
    //   const getTimeDiffFromDate(startDate, endDate) {
    const dateFuture = new Date(startDate);
    const dateNow = new Date(endDate);

    let diffInMilliSeconds = Math.abs(dateFuture - dateNow) / 1000;

    // calculate days
    const days = Math.floor(diffInMilliSeconds / 86400);
    diffInMilliSeconds -= days * 86400;
    //console.log('calculated days', days);

    // calculate hours
    const hours = Math.floor(diffInMilliSeconds / 3600) % 24;
    diffInMilliSeconds -= hours * 3600;
    //console.log('calculated hours', hours);

    // calculate minutes
    const minutes = Math.floor(diffInMilliSeconds / 60) % 60;
    diffInMilliSeconds -= minutes * 60;
    //console.log('minutes', minutes);

    let difference = "";
    if (days > 0) {
      difference += days === 1 ? `${days} d, ` : `${days} d, `;
    }

    difference += hours === 0 || hours === 1 ? `${hours} h, ` : `${hours} h, `;

    difference +=
      minutes === 0 || hours === 1 ? `${minutes} m` : `${minutes} m`;

    return difference;
  };
  const convertIntoHr = (totalMinutes) => {
    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;

    const formattedTime = `${hours}h ${minutes}m`;

    // console.log(formattedTime);
    return formattedTime;
  };

  const [fareShow, setFareShow] = useState(false);

  const getTotalTax = (fare) => {
    const adultTax = parseFloat(fare.ADULT?.fC?.TAF) || 0;
    const childTax = parseFloat(fare.CHILD?.fC?.TAF) || 0;
    const infantTax = parseFloat(fare.INFANT?.fC?.TAF) || 0;

    // Perform addition
    const totalFare = adultTax + childTax + infantTax;

    // Return the result
    return totalFare;
  };

  const getBaseFare = (fare, pax) => {
    const adultBaseFare = Number(fare.ADULT?.fC?.BF * pax.ADULT) || 0;
    const childBaseFare = Number(fare.CHILD?.fC?.BF * pax.CHILD) || 0;
    const infantBaseFare = Number(fare.INFANT?.fC?.BF * pax.INFANT) || 0;

    // Perform addition
    const totalFare = adultBaseFare + childBaseFare + infantBaseFare;

    // Return the result
    return totalFare;
  };
  const [ssrInfo, setSsrInfo] = useState(null);
  const [showSSRModal, setShowSSRModal] = useState(false);
  const handleClose = () => setShowSSRModal(false);
  const handleShow = (details) => {
    setShowSSRModal(true);

    setSsrInfo(details);
  };
  return (
    <>
      <div>
        <Modal
          show={show}
          fullscreen={"xxl-down"}
          onHide={() => setShow(false)}
        >
          <Modal.Header closeButton>
            <Modal.Title>Offline Booking preview</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {isShow ? (
              <>
                <div>
                  <Spinner
                    animation="border"
                    role="status"
                    style={{
                      justifyContent: "center",
                      display: "flex",
                      marginLeft: "50%",
                    }}
                  ></Spinner>
                  <span className="sr-only">Loading...</span>
                </div>
              </>
            ) : (
              <>
                <Container>
                  <Row style={{ marginBottom: 10 }}>
                    <Col>
                      <Card style={{ marginTop: 5, marginBottom: 5 }}>
                        <Card.Body>
                          <Container>
                            <Row
                              className="justify-content-md-center"
                              style={{
                                borderBottom: "1px solid #ba92e3", // Ensure border is solid and black
                                borderBottomWidth: "1px", // Optional: specify border bottom width
                                borderBottomStyle: "solid",
                              }}
                            >
                              <Col
                                md="auto"
                                style={{ fontSize: 18, fontWeight: "bold" }}
                                className="text-primary"
                              >
                                Affiliate Details
                              </Col>
                            </Row>
                            <Row className="justify-content-md-center mt-1">
                              <Col md="auto" style={{ fontWeight: "600" }}>
                                {affiliateResponse?.label}
                              </Col>
                            </Row>
                            <Row className="justify-content-md-center mt-1">
                              <Col md="auto">
                                <div
                                //   className="text-primary"
                                //   style={{ fontWeight: "600" }}
                                >
                                  Wallet Balence : {affiliateResponse?.balance}
                                </div>
                              </Col>
                            </Row>
                          </Container>
                        </Card.Body>
                      </Card>
                    </Col>
                    <Col>
                      <Card style={{ marginTop: 5, marginBottom: 5 }}>
                        <Card.Body>
                          <Container>
                            <Row
                              className="justify-content-md-center"
                              style={{
                                borderBottom: "1px solid #ba92e3", // Ensure border is solid and black
                                borderBottomWidth: "1px", // Optional: specify border bottom width
                                borderBottomStyle: "solid",
                              }}
                            >
                              <Col
                                md="auto"
                                style={{ fontSize: 18, fontWeight: "bold" }}
                                className="text-primary"
                              >
                                Booking Id & Ref No.
                              </Col>
                            </Row>
                            <Row className="justify-content-md-center mt-2">
                              <Col md="4">Booking Id -</Col>
                              <Col md="8">{values?.bookingId}</Col>
                              <Col md="4">Ref No. -</Col>
                              <Col md="8">{values?.bookingReferenceNumber}</Col>
                            </Row>
                          </Container>
                        </Card.Body>
                      </Card>
                    </Col>
                    <Col>
                      <Card style={{ marginTop: 5, marginBottom: 5 }}>
                        <Card.Body>
                          <Container>
                            <Row
                              className="justify-content-md-center"
                              style={{
                                borderBottom: "1px solid #ba92e3", // Ensure border is solid and black
                                borderBottomWidth: "1px", // Optional: specify border bottom width
                                borderBottomStyle: "solid",
                              }}
                            >
                              <Col
                                md="auto"
                                style={{ fontSize: 18, fontWeight: "bold" }}
                                className="text-primary"
                              >
                                Affiliate Service
                              </Col>
                            </Row>
                            <Row className="justify-content-md-center mt-4 mb-1">
                              <Col md="auto" style={{ fontWeight: "600" }}>
                                Flight Offline Ticket Booking
                              </Col>
                            </Row>
                          </Container>
                        </Card.Body>
                      </Card>
                    </Col>
                  </Row>
                </Container>
                {review?.tripInfos.map((res, index) => (
                  <>
                    <Card style={{ marginTop: index == 1 && 10 }} key={index}>
                      {index == 0 ? (
                        <Card.Header as="h5">
                          <Tooltip
                            placement="top"
                            overlay={
                              <div style={{ maxWidth: "auto" }}>
                                {
                                  review?.searchQuery?.routeInfos[0]
                                    ?.fromCityOrAirport?.name
                                }
                              </div>
                            }
                          >
                            <span style={{ cursor: "pointer" }}>
                              {
                                review?.searchQuery?.routeInfos[0]
                                  ?.fromCityOrAirport?.city
                              }{" "}
                            </span>
                          </Tooltip>
                          <FaLongArrowAltRight />{" "}
                          <Tooltip
                            placement="top"
                            overlay={
                              <div style={{ maxWidth: "auto" }}>
                                {
                                  review?.searchQuery?.routeInfos[0]
                                    ?.toCityOrAirport?.name
                                }
                              </div>
                            }
                          >
                            <span style={{ cursor: "pointer" }}>
                              {
                                review?.searchQuery?.routeInfos[0]
                                  ?.toCityOrAirport?.city
                              }{" "}
                            </span>
                          </Tooltip>{" "}
                          <span style={{ color: "GrayText" }}>
                            on{" "}
                            {moment(
                              review?.searchQuery?.routeInfos[0]?.travelDate
                            ).format("ddd, MMM Do, YYYY")}
                          </span>
                        </Card.Header>
                      ) : (
                        <Card.Header as="h5">
                          <Tooltip
                            placement="top"
                            overlay={
                              <div style={{ maxWidth: "auto" }}>
                                {
                                  review?.searchQuery?.routeInfos[1]
                                    ?.fromCityOrAirport?.name
                                }
                              </div>
                            }
                          >
                            <span style={{ cursor: "pointer" }}>
                              {
                                review?.searchQuery?.routeInfos[1]
                                  ?.fromCityOrAirport?.city
                              }{" "}
                            </span>
                          </Tooltip>
                          <FaLongArrowAltRight />{" "}
                          <Tooltip
                            placement="top"
                            overlay={
                              <div style={{ maxWidth: "auto" }}>
                                {
                                  review?.searchQuery?.routeInfos[1]
                                    ?.toCityOrAirport?.name
                                }
                              </div>
                            }
                          >
                            <span style={{ cursor: "pointer" }}>
                              {
                                review?.searchQuery?.routeInfos[1]
                                  ?.toCityOrAirport?.city
                              }{" "}
                            </span>
                          </Tooltip>{" "}
                          <span style={{ color: "GrayText" }}>
                            on{" "}
                            {moment(
                              review?.searchQuery?.routeInfos[1]?.travelDate
                            ).format("ddd, MMM Do, YYYY")}
                          </span>
                        </Card.Header>
                      )}

                      <Card.Body>
                        {/* <Card.Title>Special title treatment</Card.Title> */}
                        {review?.tripInfos[index].sI.map((seg, id) => (
                          <>
                            <Card.Text
                              key={id}
                              style={{ marginTop: id == 1 && 20 }}
                            >
                              <Row>
                                <Col>
                                  <Image
                                    src={`/assets/images/airlineLogo/${seg?.fD.aI.code}.gif`}
                                    //   src={`/assets/images/airline-logo/${seg?.fD.aI.code}.gif`}
                                    alt={seg?.fD.aI.code}
                                    height="35"
                                    width={"35"}
                                    style={{ borderRadius: 15 }}
                                  />
                                  <div>
                                    {`${seg.fD.aI.name} ${seg?.fD.aI.code} ${seg?.fD.fN}`}{" "}
                                  </div>
                                </Col>
                                <Col>
                                  <div style={{ fontWeight: "bold" }}>
                                    {moment(seg?.dt).format(
                                      "ddd, MMM Do, YYYY, hh:mm a"
                                    )}
                                  </div>
                                  <div>
                                    {seg?.da?.city} ({seg?.da?.cityCode}),{" "}
                                    {seg?.da?.country}
                                  </div>
                                  <div>
                                    {seg?.da?.name.length >= 18 ? (
                                      <Tooltip
                                        placement="top"
                                        overlay={
                                          <div style={{ maxWidth: 250 }}>
                                            {seg?.da?.name}
                                          </div>
                                        }
                                      >
                                        <span style={{ cursor: "pointer" }}>
                                          {seg?.da?.name.substring(0, 18) +
                                            "..."}
                                        </span>
                                      </Tooltip>
                                    ) : (
                                      seg?.da?.name
                                    )}
                                  </div>
                                  <div>{seg?.da?.terminal}</div>
                                </Col>
                                <Col style={{ marginLeft: 35 }}>
                                  <div style={{ marginTop: 20 }}>
                                    <FaPlaneDeparture
                                      size={20}
                                      className="text-primary"
                                    />
                                    .............
                                    <MdOutlineLocationOn
                                      size={20}
                                      className="text-primary"
                                    />
                                    .............
                                    <FaPlaneArrival
                                      size={20}
                                      className="text-primary"
                                    />
                                  </div>
                                </Col>

                                <Col>
                                  <div style={{ fontWeight: "bold" }}>
                                    {moment(seg?.at).format(
                                      "ddd, MMM Do, YYYY, hh:mm a"
                                    )}
                                  </div>
                                  <div>
                                    {seg?.aa?.city} ({seg?.aa?.cityCode}),{" "}
                                    {seg?.aa?.country}
                                  </div>
                                  <div>
                                    {seg?.aa?.name.length >= 18 ? (
                                      <Tooltip
                                        placement="top"
                                        overlay={
                                          <div style={{ maxWidth: 250 }}>
                                            {seg?.aa?.name}
                                          </div>
                                        }
                                      >
                                        <span style={{ cursor: "pointer" }}>
                                          {seg?.aa?.name.substring(0, 18) +
                                            "..."}
                                        </span>
                                      </Tooltip>
                                    ) : (
                                      seg?.aa?.name
                                    )}
                                  </div>
                                  <div>{seg?.aa?.terminal}</div>
                                </Col>

                                <Col>
                                  <div style={{ fontWeight: "bold" }}>
                                    {getTimeDiffFromDate(seg?.dt, seg?.at)}{" "}
                                  </div>
                                  <div>
                                    {res?.totalPriceList[0]?.fd?.ADULT.cc} |{" "}
                                    {res?.totalPriceList[0]?.fd?.ADULT.rT == 1
                                      ? "Refundable"
                                      : res?.totalPriceList[0]?.fd?.ADULT.rT ==
                                        0
                                      ? "Non Refundable"
                                      : "Partial Refundable"}
                                    {res?.totalPriceList[0]?.fd?.ADULT.mI ==
                                      true && " | Free Meal"}
                                  </div>
                                  <div>
                                    <span style={{ fontWeight: "bold" }}>
                                      Baggage:
                                    </span>
                                    <div
                                      style={{ marginLeft: 10, fontSize: 12 }}
                                    >
                                      {res?.totalPriceList[0]?.fd?.ADULT.bI
                                        .iB != null && (
                                        <>
                                          Checking Baggage:{" "}
                                          {
                                            res?.totalPriceList[0]?.fd?.ADULT.bI
                                              .iB
                                          }
                                        </>
                                      )}
                                    </div>
                                    <div
                                      style={{ marginLeft: 10, fontSize: 12 }}
                                    >
                                      {res?.totalPriceList[0]?.fd?.ADULT.bI
                                        .cB != null && (
                                        <>
                                          Cabin Baggage:{" "}
                                          {
                                            res?.totalPriceList[0]?.fd?.ADULT.bI
                                              .cB
                                          }
                                        </>
                                      )}
                                    </div>
                                  </div>
                                </Col>
                              </Row>
                            </Card.Text>
                            <Row>
                              {seg?.cT != null && (
                                <div>
                                  <div>
                                    <div
                                      style={{
                                        width: "39%",
                                        float: "left",
                                        marginTop: "11px",
                                      }}
                                    >
                                      <div
                                        style={{
                                          borderBottom: "1px solid teal",
                                        }}
                                      ></div>
                                    </div>
                                    <div
                                      className="bg-primary"
                                      style={{
                                        width: "20%",
                                        float: "left",
                                        textAlign: "center",
                                        //   backgroundColor: "rgb(161, 11, 56)",
                                        borderRadius: "10px",
                                        marginLeft: "5px",
                                        marginRight: "5px",
                                        color: "white",
                                        fontWeight: "700",
                                      }}
                                    >
                                      Layover Time - {convertIntoHr(seg?.cT)}
                                    </div>
                                    <div
                                      style={{
                                        width: "40%",
                                        float: "left",
                                        marginTop: "11px",
                                      }}
                                    >
                                      <div
                                        style={{
                                          borderBottom: "1px solid teal",
                                        }}
                                      ></div>
                                    </div>
                                  </div>
                                </div>
                              )}
                            </Row>
                          </>
                        ))}
                        <Row>
                          <Col>
                            <Button
                              className="bg-primary text-white"
                              style={{ marginLeft: 5 }}
                              variant="outline-primary"
                              onClick={() => {
                                setFareShow(true);
                              }}
                            >
                              Fare Summary
                            </Button>
                          </Col>
                        </Row>
                      </Card.Body>
                    </Card>
                  </>
                ))}
                <div
                  className="modal-body"
                  id="printModal"
                  style={{ marginTop: 10 }}
                >
                  <span
                    style={{
                      fontSize: "22px",
                      marginBottom: "10px",
                      fontWeight: "bold",
                    }}
                  >
                    Passenger Details :
                  </span>
                  <div>
                    <div className="col-12">
                      <table className="table table-striped border text-center table-inverse">
                        <thead className="thead-inverse  bg-primary text-white">
                          <tr>
                            {/* <th scope="col">Title</th> */}
                            <th scope="col">Name</th>
                            {/* <th scope="col">Last Name</th> */}

                            {/* <th scope="col">Passenger Type</th> */}
                            <th scope="col">PNR</th>
                            <th>Date of Birth</th>
                            {pnrResponse?.isDomestic == "International" && (
                              <>
                                <th scope="col">Passport No.</th>
                                <th scope="col">Passport Issue Date</th>
                                <th scope="col">Passport Expiry Date</th>
                                <th scope="col">Passport Nationality</th>
                              </>
                            )}
                            <th></th>
                          </tr>
                        </thead>

                        <tbody className="text-center">
                          {pnrResponse?.itemInfos?.AIR?.travellerInfos?.map(
                            (passenger, id) => {
                              return (
                                <tr key={id}>
                                  {/* <td scope="row">{passenger?.title}</td> */}
                                  <td>
                                    {passenger?.ti} {passenger?.fN}{" "}
                                    {passenger?.lN} ({passenger?.pt})
                                  </td>

                                  <td>
                                    {Object.entries(passenger?.pnrDetails).map(
                                      ([route, pnr]) => (
                                        <div key={route}>
                                          {route}: {pnr}
                                        </div>
                                      )
                                    )}
                                  </td>
                                  <td>
                                    {passenger?.dob?.length > 0
                                      ? passenger.dob
                                      : "Not available"}
                                  </td>
                                  {pnrResponse.isDomestic ==
                                    "International" && (
                                    <>
                                      <td>
                                        {passenger?.pNum != null
                                          ? passenger?.pNum
                                          : "Not Available"}
                                      </td>
                                      <td>
                                        {passenger?.pid != null
                                          ? moment(passenger?.pid).format(
                                              "DD-MM-YYYY"
                                            )
                                          : "Not Available"}
                                      </td>
                                      <td>
                                        {passenger?.eD != null
                                          ? moment(passenger?.eD).format(
                                              "DD-MM-YYYY"
                                            )
                                          : "Not Available"}
                                      </td>
                                      <td>
                                        {passenger?.pNat != null
                                          ? passenger?.pNat
                                          : "Not Available"}
                                      </td>
                                    </>
                                  )}

                                  <td>
                                    <div
                                      style={{
                                        cursor:
                                          passenger?.pt == "INFANT"
                                            ? "not-allowed"
                                            : "pointer",
                                      }}
                                    >
                                      <Button
                                        variant="outline-primary"
                                        size="sm"
                                        onClick={() => handleShow(passenger)}
                                        disabled={
                                          passenger?.pt == "INFANT"
                                            ? true
                                            : false
                                        }
                                      >
                                        More info
                                      </Button>
                                    </div>
                                  </td>
                                </tr>
                              );
                            }
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
                <SsrInfo
                  show={showSSRModal}
                  ssrInfo={ssrInfo}
                  handleClose={handleClose}
                />
                <Row>
                  <FareSummary
                    calculateSSRAmount={calculateSSRAmount}
                    flightCommTypeOnWard={flightCommTypeOnWard}
                    totalCarrierServiceChargesOnWard={
                      totalCarrierServiceChargesOnWard
                    }
                    flightCommTypeReturn={flightCommTypeReturn}
                    totalCarrierServiceChargesReturn={
                      totalCarrierServiceChargesReturn
                    }
                    values={values}
                    fareShow={fareShow}
                    setFareShow={setFareShow}
                    review={review}
                    getTotalTax={getTotalTax}
                    getBaseFare={getBaseFare}
                  />
                </Row>
              </>
            )}
          </Modal.Body>
          <Modal.Footer>
            <Container style={{ justifyContent: "flex-end", display: "flex" }}>
              <Row>
                <Col>
                  {values?.balance <= 0 && (
                    <div style={{ color: "red" }}>User Inefficient Balance</div>
                  )}
                </Col>
              </Row>
            </Container>
            <Container style={{ justifyContent: "flex-end", display: "flex" }}>
              <Row>
                <Col>
                  <Button
                    style={{ marginRight: 5 }}
                    variant="secondary"
                    onClick={() => setShow(false)}
                  >
                    Close
                  </Button>

                  {values?.balance <= 0 ? (
                    <Button
                      disabled
                      className="btn btn-primary"
                      style={{ cursor: "not-allowed" }}
                    >
                      Create Booking
                    </Button>
                  ) : isLoading == true ? (
                    <Button variant="primary" disabled={true}>
                      <Spinner animation="border" size="sm" />
                    </Button>
                  ) : (
                    <Button
                      variant="primary"
                      onClick={() => offlineBooking(response)}
                    >
                      Create Booking
                    </Button>
                  )}
                </Col>
              </Row>
            </Container>
          </Modal.Footer>
        </Modal>
      </div>
    </>
  );
}
